


import { apiRequest } from '../../apiCall'
import { registerTicketReq, replyTicketReq } from '../../types/ticket/apiRequestTypes'


export const getTicketsByUser = () => apiRequest('Tickets.GetTicketsByUser', {}, '', false)
export const viewTickets = () => apiRequest('viewTickets.registerTicketHtml', {}, '', false)
export const registerTicketBuyUser = (params: registerTicketReq) => apiRequest('Tickets.RegisterTicket', params, '', false)
export const getTicketById = (params: string) => apiRequest('Tickets.GetTicketResponsesById', {}, `?TicketId=${params}`, false)
export const replyTicket = (params: replyTicketReq) => apiRequest('Tickets.ReplyTicket', params, '', false)
export const getCustomerFullName = () =>(apiRequest('Customer.GetCustomerFullName', {}, '', false))



